/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, BigNumberish } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { NFTRafflePoolController } from "../NFTRafflePoolController";

export class NFTRafflePoolController__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _addressRegistry: string,
    _feeRecipient: string,
    _platformFee: BigNumberish,
    _apesFee: BigNumberish,
    overrides?: Overrides
  ): Promise<NFTRafflePoolController> {
    return super.deploy(
      _addressRegistry,
      _feeRecipient,
      _platformFee,
      _apesFee,
      overrides || {}
    ) as Promise<NFTRafflePoolController>;
  }
  getDeployTransaction(
    _addressRegistry: string,
    _feeRecipient: string,
    _platformFee: BigNumberish,
    _apesFee: BigNumberish,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      _addressRegistry,
      _feeRecipient,
      _platformFee,
      _apesFee,
      overrides || {}
    );
  }
  attach(address: string): NFTRafflePoolController {
    return super.attach(address) as NFTRafflePoolController;
  }
  connect(signer: Signer): NFTRafflePoolController__factory {
    return super.connect(signer) as NFTRafflePoolController__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NFTRafflePoolController {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as NFTRafflePoolController;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_addressRegistry",
        type: "address",
      },
      {
        internalType: "address",
        name: "_feeRecipient",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "_platformFee",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "_apesFee",
        type: "uint16",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
    ],
    name: "PoolCanceled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "pool",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "nft",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "payToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "quantity",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "end",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "max",
        type: "uint256",
      },
    ],
    name: "PoolCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "winner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "PoolResult",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
    ],
    name: "PoolSeedReset",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "round",
        type: "uint256",
      },
    ],
    name: "PoolSeedSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "payToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    name: "PoolTokenMinted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "PoolTokenTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "_poolIdTracker",
    outputs: [
      {
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "addressRegistry",
    outputs: [
      {
        internalType: "contract INFTRaffleAddressRegistry",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "apesFee",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenContract",
        type: "address",
      },
    ],
    name: "approveERC20ForRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
    ],
    name: "basePoolURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
    ],
    name: "cancelPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "payToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "nft",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "quantity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "end",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "max",
        type: "uint256",
      },
    ],
    name: "createPool",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "emitTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "feeRecipient",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "platformFee",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "poolResults",
    outputs: [
      {
        internalType: "address",
        name: "winner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "seedRound",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "pools",
    outputs: [
      {
        internalType: "address",
        name: "pool",
        type: "address",
      },
      {
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        internalType: "address",
        name: "nft",
        type: "address",
      },
      {
        internalType: "address",
        name: "payToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "quantity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "end",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "max",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
    ],
    name: "resultPool",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "roundOffset",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_roundOffset",
        type: "uint256",
      },
    ],
    name: "setRoundOffset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "poolId",
        type: "uint256",
      },
    ],
    name: "setSeedRound",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_registry",
        type: "address",
      },
    ],
    name: "updateAddressRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "_apesFee",
        type: "uint16",
      },
    ],
    name: "updateApesFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_feeRecipient",
        type: "address",
      },
    ],
    name: "updateFeeRecipient",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_maxDuration",
        type: "uint256",
      },
    ],
    name: "updateMaxDuration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "_platformFee",
        type: "uint16",
      },
    ],
    name: "updatePlatformFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
